import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { withTheme } from 'styled-components';
import Loading from 'components/Loading';
import Pagination from 'components/Pagination';
import Spacer from 'components/Spacer';
import {
  withEventYearFilterContext,
  YearDropdown,
} from 'components/YearDropdown';
import { IssueCreditModal } from 'pages/app/Credits/issueCreditModal';
import { useGetTrackRedeemedCredits } from 'pages/track/CreditTrack/TrackRedeemedCredits/gql/get-track-redeemed-credits';
import MobileSearchInput from '../../GuestList/GuestListEventsMobile/search';
import CreditList from '../CreditsList/CreditList';
import { IssueButton } from '../TrackOpenCreditMobile/TrackOpenCreditMobile';

const TrackRedeemedCreditMobile = withEventYearFilterContext((props) => {
  const { location, match, history } = props;

  const urlParams = new URLSearchParams(location.search);
  const currentPage = parseInt(urlParams.get('page'));

  const { pathname } = useLocation();
  const userType = pathname?.split('/').includes('admin-employee')
    ? 'employee'
    : 'track';

  const [users, setUsers] = useState();
  const [count, setCount] = useState();
  const [search, setSearch] = useState('');
  const [showIssueCredit, setShowIssueCredit] = useState(false);

  const { resRedeemed, loading } = useGetTrackRedeemedCredits();

  useEffect(() => {
    if (resRedeemed && resRedeemed.getTrackRedeemedCredits) {
      setUsers(resRedeemed?.getTrackRedeemedCredits?.results);
      setCount(resRedeemed?.getTrackRedeemedCredits?.count);
    }
  }, [resRedeemed]);

  const searchValue = (value) => {
    if (value.length > 0) {
      history.push(`${match.url}?queryString=${value}`);
    } else if (value.length === 0) history.push(`${match.url}`);
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    searchValue(e.target.value);
  };

  const handleBlur = (e) => {
    searchValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      searchValue(e.target.value);
    }
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <div style={{ justifyContent: 'center', alignContent: 'center' }}>
        <MobileSearchInput
          placeholder="Search Credits"
          onChange={handleChange}
          value={search}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleKeyPress={handleKeyPress}
        />
        <Spacer size={10} />

        <div
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            margin: 'auto',
          }}
        >
          <IssueButton onClick={() => setShowIssueCredit(true)}>
            {'Issue Credit'}
          </IssueButton>
        </div>

        <Spacer size={10} />
        <div
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            margin: 'auto',
          }}
        >
          <YearDropdown showLabel={false} />
        </div>

        <Spacer size={10} />
        {users ? (
          <CreditList
            search={search}
            users={users}
            url={`/admin-${userType}/redeemedCredits/creditDetail`}
            currentPage={currentPage}
          />
        ) : null}
        <div
          style={{ backgroundColor: '#00001F', margin: 10, borderRadius: 5 }}
        >
          <Pagination
            count={count ?? 0}
            perPage={15}
            currentPage={currentPage || 1}
            color={'#fff'}
          />
        </div>
        <Spacer size={40} />
      </div>
      <IssueCreditModal
        setIsVisible={setShowIssueCredit}
        isVisible={showIssueCredit}
        isTrackAdmin={true}
      />
    </>
  );
});

export default withTheme(TrackRedeemedCreditMobile);
